import { render, staticRenderFns } from "./TakeoffPassengersDataEditDialog.vue?vue&type=template&id=84d5d562&"
import script from "./TakeoffPassengersDataEditDialog.vue?vue&type=script&lang=js&"
export * from "./TakeoffPassengersDataEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d5d562')) {
      api.createRecord('84d5d562', component.options)
    } else {
      api.reload('84d5d562', component.options)
    }
    module.hot.accept("./TakeoffPassengersDataEditDialog.vue?vue&type=template&id=84d5d562&", function () {
      api.rerender('84d5d562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/data/takeoffPassengersData/TakeoffPassengersDataEditDialog.vue"
export default component.exports